@if (isValid()) {
	@switch (status()) {
		@case (SessionState.Draft) {
			<div class="statusTag {{ SimStatusPalette.inactive }}">
				<mat-icon fontIcon="fa-file" fontSet="fas" />
				{{ T.SHARED_EVENT_STATE_DRAFT | translate }}
			</div>
		}
		@case (SessionState.Finished) {
			<div class="statusTag {{ SimStatusPalette.success }}">
				<mat-icon fontIcon="fa-check-double" fontSet="fas" />
				{{ T.SHARED_TRAINING_SESSION_STATE_FINISHED | translate }}
			</div>
		}
		@case (SessionState.Scheduled) {
			<div class="statusTag {{ SimStatusPalette.warn }}">
				<mat-icon fontIcon="fa-calendar-day" fontSet="fas" />
				{{ T.SHARED_TRAINING_SESSION_STATE_SCHEDULED | translate }}
			</div>
		}
		@case (SessionState.Aborted || SessionState.Canceled) {
			<div class="statusTag {{ SimStatusPalette.error }}">
				<mat-icon fontIcon="fa-exclamation-triangle" fontSet="fas" />
				{{ T.SHARED_TRAINING_SESSION_STATE_ABORTED | translate }}
			</div>
		}
		@case (SessionState.Running) {
			<ng-container [ngTemplateOutlet]="statusTagRunning" />
		}
		@case (SessionState.ExamRunning) {
			<ng-container [ngTemplateOutlet]="statusTagRunning" />
		}
		@case (SessionState.ExamConfirmationRunning) {
			<ng-container [ngTemplateOutlet]="statusTagRunning" />
		}
		@case (SessionState.ExamConfirmationClosed) {
			<ng-container [ngTemplateOutlet]="statusTagRunning" />
		}
		@case (SessionState.ExamClosing) {
			<ng-container [ngTemplateOutlet]="statusTagRunning" />
		}
	}
} @else {
	<div class="statusTag {{ SimStatusPalette.error }}">
		<mat-icon fontIcon="fa-exclamation-triangle" fontSet="fas" />
		{{ T.SHARED_TRAINING_SESSION_INVALID | translate }}
	</div>
}

<!--TAG TEMPLATE-->
<ng-template #statusTagRunning>
	<div class="statusTag {{ SimStatusPalette.busy }}">
		<mat-icon fontIcon="fa-play-circle" fontSet="fas" />
		{{ T.SHARED_TRAINING_SESSION_STATE_RUNNING | translate }}
	</div>
</ng-template>
